export default __webpack_public_path__ + "static/media/thankyouVerifyEmail.64a95faa.svg";